import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { initStateMemberData } from "mocks/memberData";
import React, { useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { base64ToBlob } from "utils/HelperFunction";
import { allowedFields, jsonKeys, mappingSo, mapProductToRequestItem } from "utils/HelperSoFunction";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import { getHQAddressByDate } from "../../redux/handlers/logic/getHQAddressByDate.handler";
import { nanoid } from "@reduxjs/toolkit";
import { getNewSoById } from "../../redux/slices/logic/getNewSoById.slice";
import { clearCreateNewSo, createNewSo } from "../../redux/slices/logic/createNewSo.slice";
import { clearUpdateNewSo, updateNewSo } from "../../redux/slices/logic/updateNewSo.slice";
import { initStateSoData } from "mocks/soData";
import { useGlobalDocModalContext } from "contexts/GlobalDocModalContext";
import { isShowBranch, mappingSearchMember } from "utils/HelperMemberFunction";
export default function useSoForm(param) {
    var soID = param.soID, setModalSuccess = param.setModalSuccess, setModalNotApprove = param.setModalNotApprove, setTab = param.setTab, setProductRow = param.setProductRow, columnsort = param.columnsort, setColumnsort = param.setColumnsort, attachments = param.attachments, setAttachments = param.setAttachments, setTagSelected = param.setTagSelected, setUpdateDocIds = param.setUpdateDocIds, modalNotApprove = param.modalNotApprove;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalDocModalContext = useGlobalDocModalContext(), modalNotiDocAlert = _useGlobalDocModalContext.modalNotiDocAlert, setModalNotiDocAlert = _useGlobalDocModalContext.setModalNotiDocAlert;
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var _obj;
    var schema = yup.object().shape((_obj = {
        doc_issue_date: yup.string().required(),
        dim_mst_price_category_id: yup.string().required(),
        fact_member_id: yup.string().required(),
        dim_mst_payment_type_id: yup.string().required()
    }, _define_property(_obj, "doc_issue_date", yup.string().required()), _define_property(_obj, "dim_warehouse_id", yup.string().required()), _define_property(_obj, "dim_branch_id", yup.string().required()), _define_property(_obj, "fact_new_so_items", yup.array().of(yup.object().shape({
        dim_warehouse_id: yup.string().required("Warehouse ID is required.")
    }))), _define_property(_obj, "member_address", yup.string().required("กรุณาเพิ่มที่อยู่ก่อน")), _define_property(_obj, "not_approve_reason", yup.string().when([], {
        is: function() {
            return modalNotApprove.open;
        },
        then: function(schema) {
            return schema.required();
        }
    })), _obj));
    // Reducers
    var reducers = {
        createNewSo: useAppSelector(function(state) {
            return state.createNewSoReducer;
        }),
        updateNewSo: useAppSelector(function(state) {
            return state.updateNewSoReducer;
        }),
        getNewSoById: useAppSelector(function(state) {
            return state.getNewSoByIdReducer;
        })
    };
    var isLoading = useMemo(function() {
        return reducers.createNewSo.isFetching || reducers.updateNewSo.isFetching || reducers.getNewSoById.isFetching;
    }, [
        reducers.createNewSo.isFetching,
        reducers.updateNewSo.isFetching,
        reducers.getNewSoById.isFetching
    ]);
    var _useState = _sliced_to_array(useState(false), 2), formdisabled = _useState[0], setFormdisabled = _useState[1];
    var _useState1 = _sliced_to_array(useState(initStateSoData), 2), formdata = _useState1[0], setFormdata = _useState1[1];
    var _useState2 = _sliced_to_array(useState(initStateMemberData), 2), pdata = _useState2[0], setPdata = _useState2[1];
    var _useState3 = _sliced_to_array(useState("สร้างใบสั่งขาย"), 2), headerName = _useState3[0], setheaderName = _useState3[1];
    var formatResult = function(item) {
        var mappingMember = mappingSearchMember(item);
        var isShowBranchMember = isShowBranch({
            custType: item.member_customer_type,
            isHQ: item.member_is_hq,
            branchNo: item.member_branch_no
        });
        return /*#__PURE__*/ _jsxs("div", {
            className: "",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        mappingMember.customerName,
                        isShowBranchMember ? " - (".concat(mappingMember.branchCode, ")") : ""
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "tc-5",
                    children: [
                        mappingMember.customerID ? mappingMember.customerID : "ไม่พบเลขผู้เสียภาษี",
                        " ",
                        "- ",
                        mappingMember.customerCode
                    ]
                })
            ]
        }, nanoid());
    };
    var getHQAddress = function(payload) {
        dispatch(getHQAddressByDate(payload, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var getData = function() {
        var id = soID;
        dispatch(getNewSoById({
            id: id,
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var handleMainSubmit = function(param) {
        var values = param.values, resetForm = param.resetForm;
        var formdataPayload = new FormData();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                var value = values[key];
                if (value === undefined || value === null) return "continue";
                if (key === "doc_files" && Array.isArray(value)) {
                    value.forEach(function(file, index) {
                        if (file.docData) {
                            var blob = base64ToBlob(file.docData);
                            formdataPayload.append(key, blob, "".concat(file.docName));
                        }
                    });
                } else if (jsonKeys.includes(key)) {
                    formdataPayload.append(key, JSON.stringify(value));
                } else if (Array.isArray(value)) {
                    value.forEach(function(item) {
                        formdataPayload.append(key, item);
                    });
                } else {
                    formdataPayload.append(key, value);
                }
            };
            for(var _iterator = allowedFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // console.log(formdataPayload);
        var id = soID;
        var payload = formdataPayload;
        if (!soID) {
            dispatch(createNewSo({
                payload: payload,
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else {
            dispatch(updateNewSo({
                id: id,
                payload: payload,
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    var handlePreSubmit = function(param) {
        var productRow = param.productRow, setFieldValue = param.setFieldValue, handleSubmit = param.handleSubmit, values = param.values, attachments = param.attachments, tagselected = param.tagselected, updateDocIds = param.updateDocIds, setModalAlert = param.setModalAlert, setErrors = param.setErrors;
        var product = productRow.filter(function(prev) {
            return prev.productCode !== "";
        });
        if (product && product.length > 0) {
            var newItems = mapProductToRequestItem(product);
            schema.validate(_object_spread_props(_object_spread({}, values), {
                fact_new_so_items: newItems,
                attachments: attachments,
                tagselected: tagselected
            }), {
                abortEarly: false
            }).then(function() {
                setFieldValue("doc_files", attachments.map(function(v) {
                    return {
                        docData: v.docFileData,
                        docName: v.docFile
                    };
                }));
                setFieldValue("fact_new_so_items", newItems);
                setFieldValue("tag_soes", tagselected);
                if (soID) {
                    setFieldValue("update_doc_ids", updateDocIds);
                }
                handleSubmit();
            }).catch(function(err) {
                var _err_errors;
                var errorMessage = ((_err_errors = err.errors) === null || _err_errors === void 0 ? void 0 : _err_errors.join("\n")) || "Invalid data. Please check the form.";
                console.log(errorMessage);
                var formErrors = {};
                err.inner.forEach(function(e) {
                    if (e.path) formErrors[e.path] = e.message;
                });
                setErrors(formErrors);
            });
        } else {
            setModalAlert(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
        }
    };
    useEffect(function() {
        if (reducers.createNewSo.data && !reducers.createNewSo.isError) {
            setModalSuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
            // setFormdisabled(true);
            dispatch(clearCreateNewSo());
            var createdData = reducers.createNewSo.data.data;
            var id = createdData && createdData.id ? createdData.id : null;
            if (id) {
                setModalNotiDocAlert(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        open: prev.extra.genDocNumber !== createdData.doc_number,
                        extra: {
                            genDocNumber: prev.extra.genDocNumber,
                            createdDocNumber: createdData.doc_number
                        }
                    });
                });
                navigate("/sale/sale-order/edit/".concat(id));
            } else {
                navigate("/sale/sale-order");
            }
        }
        if (reducers.updateNewSo.data && !reducers.updateNewSo.isError) {
            setModalNotApprove(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setModalSuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
            setTab(1);
            dispatch(clearUpdateNewSo());
            getData();
        }
        if (reducers.getNewSoById.data && !reducers.getNewSoById.isError && soID) {
            var soData = reducers.getNewSoById.data.data;
            if (!soData) {
                return navigate("/404", {
                    replace: true
                });
            }
            var dataWithReplacements = mappingSo({
                soData: soData,
                setPdata: setPdata,
                setProductRow: setProductRow,
                setFormdisabled: setFormdisabled,
                columnsort: columnsort,
                setColumnsort: setColumnsort,
                setAttachments: setAttachments,
                setTagSelected: setTagSelected
            });
            var endDate = dataWithReplacements.doc_issue_date;
            getHQAddress({
                end_date: endDate
            });
            setFormdata(dataWithReplacements);
        }
    }, [
        reducers.createNewSo.data,
        reducers.updateNewSo.data,
        reducers.getNewSoById.data
    ]);
    useEffect(function() {
        if (soID) {
            getData();
            setheaderName("แก้ไขใบสั่งขาย");
        } else {
            setFormdata(initStateSoData);
        }
    }, [
        soID
    ]);
    useEffect(function() {
        if (soID && (formdata === null || formdata === void 0 ? void 0 : formdata.factDocFileSo)) {
            var deleteCandidateDocIds = formdata.factDocFileSo.map(function(item) {
                return item.id;
            });
            var deleteDocIds = deleteCandidateDocIds.filter(function(docId) {
                return !attachments.some(function(doc) {
                    return doc.docId === docId;
                });
            });
            setUpdateDocIds(deleteDocIds);
        }
    }, [
        formdata,
        attachments
    ]);
    useEffect(function() {
        setIsLoading(isLoading);
    }, [
        isLoading
    ]);
    return {
        schema: schema,
        formdisabled: formdisabled,
        setFormdisabled: setFormdisabled,
        formdata: formdata,
        setFormdata: setFormdata,
        pdata: pdata,
        setPdata: setPdata,
        formatResult: formatResult,
        handleMainSubmit: handleMainSubmit,
        handlePreSubmit: handlePreSubmit,
        headerName: headerName
    };
}
